import { TextField } from "../../../atoms/Form";
import { type ConstructedTextField } from "../types";

export const FIELD_NAME_DESCRIPTION = "description";

const MIN_ROWS = 3;

const tLabel = "Description";
const tRequired = "Description is required";
const tLengthMin = "Description must be at least 2 characters";

export interface DescriptionProps extends ConstructedTextField {
  required?: boolean;
  maxLength?: number;
}

export const Description = ({ required, maxLength, textFieldProps, ...props }: DescriptionProps) => {
  return (
    <TextField
      name={FIELD_NAME_DESCRIPTION}
      textFieldProps={{
        label: tLabel,
        multiline: true,
        required,
        rows: MIN_ROWS,
        ...textFieldProps,
        inputProps: {
          ...textFieldProps?.inputProps,
          ...(maxLength !== undefined ? { maxLength } : {}),
        },
      }}
      validate={(value, _, meta) => {
        if (required && meta?.modified && !value) {
          return tRequired;
        }

        if (meta?.dirty && value) {
          if (value.length < 2) {
            return tLengthMin;
          }

          if (maxLength !== undefined && value.length > maxLength) {
            return `Description cannot exceed ${maxLength} characters`;
          }
        }

        return "";
      }}
      {...props}
    />
  );
};
